import { Component, OnInit } from '@angular/core';
import { SharedDataService } from "../shared-data.service";
import { Router } from '@angular/router';
import { ApiOpenmindService } from '../apiopenmind.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  public objUser: any;
  showError: boolean;

  studyLevel = [
    { id: "Primaria", name: "Primaria" },
    { id: "Secundaria", name: "Secundaria" },
    { id: "Universitario", name: "Universitario" },
    { id: "Especialización", name: "Especialización" },
    { id: "Maestría", name: "Maestría" },
    { id: "Doctorado", name: "Doctorado" },
  ];

  constructor(private router: Router, private sharedData: SharedDataService, private apiopenmindservice: ApiOpenmindService) { }

  ngOnInit() {
    this.loadUser();
  }

  loadUser() {

    this.sharedData.currentUser.subscribe(message => this.objUser = message);
    if (this.objUser != null && this.objUser != "") {
      this.objUser = JSON.parse(this.objUser);
      this.apiopenmindservice.GetUserById(this.objUser.userid).toPromise().then(x => {
        if (x != null && x != "") {
          this.objUser = JSON.parse(x);
        }
        else {
          console.log("Error trayendo la data del usuario con Id" + this.objUser.userid);
        }
      });
    }
    else {
      this.router.navigate(['/']);
    }
  }


  validateUser() {
    this.sharedData.userLoggedSession(this.objUser);
    sessionStorage.setItem("loginData", JSON.stringify(this.objUser));
  }


  saveProfile() {
    this.showError = false;
    this.apiopenmindservice.SaveUser(this.objUser.userResponse).subscribe(event => {
      this.apiopenmindservice.LoginUser(this.objUser.userResponse).subscribe(event => {
        this.objUser = event, this.validateUser();
        alert("Hemos actualizado tu perfil correctamente");
      }, error => { });
    }
      , error => {
        this.objUser.userResponse.errorMessage = 'Error guardando perfil de usuario';
        this.showError = true;
        console.log("ERROR");
      });
  }

}
